import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getNonBankLiquidityThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getBankLiquidity',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getLiquidity(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankLiquidity = createAsyncThunk(
  'financialAnalysis/NonBank/downloadBankLiquidity',
  async (data) => {
    const response = await FinancialAnalysisService.downloadLiquidity(data)
    handleExport(response.data, response.filename)
  },
)
